import React from 'react'
import './sidebar.scss'
import DashboardIcon from "@mui/icons-material/Dashboard";
import LanguageIcon from '@mui/icons-material/Language';
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import VoicemailIcon from '@mui/icons-material/Voicemail';
import MicIcon from '@mui/icons-material/Mic';
import VideocamIcon from '@mui/icons-material/Videocam';
import FolderIcon from '@mui/icons-material/Folder';
import ImageIcon from '@mui/icons-material/Image';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import SmsIcon from '@mui/icons-material/Sms';

import PolicyIcon from '@mui/icons-material/Policy';
import DescriptionIcon from '@mui/icons-material/Description';

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
//import DarkModeIcon from '@mui/icons-material/DarkMode';
//import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';
import { Link } from "react-router-dom";
import Login from '../../pages/login/Login';
import { useNavigate } from "react-router-dom";
//import { DarkModeContext } from "../../context/darkModeContext";
//import { useContext } from "react";
//import { logout } from '../../firebase';
import { UserAuth } from '../../context/AuthContext'




const Sidebar = () => {
  const { logout } = UserAuth();
  const navigate = useNavigate();

  // Log out function
  const handleLogout = async () => {
    try {
      await logout();
      localStorage.removeItem('token');
      navigate("/login");
      //window.localStorage.removeItem("user");
      //console.log('You are logged out')
    } catch (e) {
      //console.log(e.message);
    }

  }


  //const { dispatch } = useContext(DarkModeContext);
  return (
    <div className="sidebar">
      <div className="top">
        <Link to="/" style={{ textDecoration: "none" }}>
          <span className="logo">Voicemail Saver App</span><br />
          <span className="logo">Cloud Access</span>
        </Link>
      </div>
      <hr />
      <div className="center">
        <ul>
          <p className="title">MAIN</p>
          <Link to="/" style={{ textDecoration: "none" }}>
            <li>
              <DashboardIcon className="icon" />
              <span>Dashboard</span>
            </li>
          </Link>
          <a href={"https://voicemailsaver.com"} style={{ textDecoration: "none" }} target='_blank'>
            <li>
              <LanguageIcon className="icon" />
              <span>Main Site</span>
            </li>
          </a>
          {/* <p className="title">USER</p>
          <Link to="/users/current" style={{ textDecoration: "none" }}>
          <li>
            <AccountCircleOutlinedIcon className="icon" />
            <span>Profile</span>
          </li>
          </Link> */}
          <p className="title">LISTS</p>
          <Link to="/list/voicemails" style={{ textDecoration: "none" }}>
            <li>
              <VoicemailIcon className="icon" />
              <span>Voicemails</span>
            </li>
          </Link>
          <Link to="/list/sms" style={{ textDecoration: "none" }}>
            <li>
              <SmsIcon className="icon" />
              <span>SMS</span>
            </li>
          </Link>
          <Link to="/list/images" style={{ textDecoration: "none" }}>
            <li>
              <ImageIcon className="icon" />
              <span>Photos</span>
            </li>
          </Link>
          <Link to="/list/videos" style={{ textDecoration: "none" }}>
            <li>
              <VideocamIcon className="icon" />
              <span>Videos</span>
            </li>
          </Link>
          <Link to="/list/contacts" style={{ textDecoration: "none" }}>
            <li>
              <PersonIcon className="icon" />
              <span>Contacts</span>
            </li>
          </Link>
          <Link to="/list/documents" style={{ textDecoration: "none" }}>
            <li>
              <FolderIcon className="icon" />
              <span>Documents</span>
            </li>
          </Link>
          <Link to="/list/audios" style={{ textDecoration: "none" }}>
            <li>
              <MicIcon className="icon" />
              <span>Audios</span>
            </li>
          </Link>

          <p className="title">LEGAL</p>
          <a href={"https://www.voicemailsaver.com/app/app-privacy-policy"} style={{ textDecoration: "none" }} target='_blank'>
            <li>
              <PolicyIcon className="icon" />
              <span>Privacy Policy</span>
            </li>
          </a>
          <a href={"https://www.voicemailsaver.com/app/app-terms-and-conditions"} style={{ textDecoration: "none" }} target='_blank'>
            <li>
              <DescriptionIcon className="icon" />
              <span>Terms and Conditions</span>
            </li>
          </a>


          {/* <Link to="/users" nome={'AJA'} style={{ textDecoration: "none" }}>
            <li>
              <PersonOutlineIcon className="icon" />
              <span>Users</span>
            </li>
          </Link>
          <Link to="/users/new" style={{ textDecoration: "none" }}>
          <li>
            <AddCircleOutlineOutlinedIcon className="icon" />
            <span>Add</span>
          </li>
          </Link>
          <Link to="/products" style={{ textDecoration: "none" }}>
            <li>
              <PersonOutlineIcon className="icon" />
              <span>Products</span>
            </li>
          </Link> */}
          {/* <p className="title">SETTINGS</p>
          <li>
            <SettingsOutlinedIcon className="icon" />
            <span>Settings</span>
          </li> */}
          <p className="title">SESSION</p>
          <li>
            <a onClick={handleLogout} href={Login}><LogoutIcon className="icon" /><span>logout</span></a>

          </li>
        </ul>
      </div>
      {/* <div className="bottom">
        <DarkModeIcon className="colorOption"
          onClick={() => dispatch({ type: "DARK" })}
        />
        <WbSunnyOutlinedIcon className="colorOption"
          onClick={() => dispatch({ type: "LIGHT" })}
        />
      </div>  */}
    </div>
  );
};


export default Sidebar;